<div class="plan-gate-banner">
  <app-info-banner
    variant="warning"
    iconUrl="/public/svgs/info.svg"
    [title]="titleText()"
    [message]="messageText()"
    [ariaLabel]="titleText()"
  />
  <div class="plan-gate-banner__actions">
    @if (showAiBoost()) {
      <button
        type="button"
        class="plan-gate-banner__upgrade"
        [disabled]="boostLoading()"
        (click)="buyAiBoost()"
      >
        {{ boostLabel() }}
      </button>
      <a
        class="plan-gate-banner__secondary"
        [routerLink]="upgradeLink"
        [queryParams]="upgradeQueryParams"
      >
        {{ 'app.components.parentAiAssistant.planGateUpgrade' | translate }}
      </a>
    } @else {
      <a
        class="plan-gate-banner__upgrade"
        [routerLink]="upgradeLink"
        [queryParams]="upgradeQueryParams"
      >
        {{ 'app.components.parentAiAssistant.planGateUpgrade' | translate }}
      </a>
    }
    <button
      type="button"
      class="plan-gate-banner__dismiss"
      (click)="dismiss()"
    >
      {{ 'app.components.parentAiAssistant.planGateDismiss' | translate }}
    </button>
  </div>
  @if (boostError()) {
    <p class="plan-gate-banner__error" role="alert">
      {{ 'app.components.parentAiAssistant.planGateBoostError' | translate }}
    </p>
  }
</div>
